<template>
    <div class="vsebina ">

        <div class="glava_vsebine adapt v-adapt">

            <div class="cols">
                <div class="col left grid-col-6">
                    <h1>Živali</h1>
                </div>



                <div class="col right">
                </div>

            </div>
        </div>

        <div class="telo_vsebine adapt v-adapt">
            <div>
                <div :style="{ display: 'inline-block' }">
                    Sezona
                    <br />
                    <dropdownlist :data-items="sezoneBranje" :text-field="'sezona'" @change="sezonaChange"
                        :value="dataSezona" />

                </div>
            </div>

            <div class="uporabnik-spacer" style="margin-top:2rem"></div>
            <div class="columnBar">
                <kendo-multiselect :data-source="columns" :data-text-field="'title'" :data-value-field="'field'"
                    :placeholder="'Skrij stolpce'" @select="skrijStolpec" @deselect="prikaziStolpec"
                    :filter="'contains'" :auto-width="true" :value="hiddenColumns">
                </kendo-multiselect>
            </div>
            <div class="grid-wrapper">
                <Grid :sortable="sortable" :filterable="filterable" :pageable="pageable" :data-items="dataResult"
                    :skip="skip" :take="take" :sort="sort" :resizable="true" @columnresize="columnresize"
                    :filter="filter" :columns="columns" @datastatechange="dataStateChange" :expand-field="'expanded'"
                    @pagechange="pageChangeHandler">
                    
                    <template v-slot:nogaStMidov="{ props }">
                        <span>{{ nogaStMidov() }}</span>
                    </template>
                    <template v-slot:nogaVsotaStevilo="{ props }">
                        <span>{{ nogaVsotaStevilo() }}</span>
                    </template>
                    <template v-slot:nogaVsotaGvz="{ props }">
                        <span>{{ nogaVsotaGvz() }}</span>
                    </template>

                    <toolbar>

                        <div class="km-widget km-buttongroup k-widget k-button-group">
                            <button title="Išči" class="k-button k-primary" @click="naloziPodatke">
                                Išči
                            </button>
                            <button title="Izvozi v Excel" class="k-button k-primary" @click="exportExcel">
                                Izvozi v Excel
                            </button>

                        </div>

                    </toolbar>
                </Grid>
                <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin" /></div>
            </div>

        </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
Vue.component('kendo-multiselect', MultiSelect);


import { process } from '@progress/kendo-data-query';




Vue.component('Grid', Grid);
Vue.component('toolbar', GridToolbar);
Vue.component('dropdownlist', DropDownList);



export default {
    props: ['sezona'],
    data() {
        return {

            dataSezona: this.sezona,
            loading: false,



            filter: null,
            editID: null,
            skip: 0,
            take: 50,
            pageSize: 50,
            sortable: true,
            filterable: true,
            groupable: false,

            expandedItems: [],
            dataResult: [],
            columns: [
                { field: "kmgmid", title: "KMG-MID", width: "210px", footerCell: 'nogaStMidov' },
                { field: "kontrolnastevilka", title: "Kont. št.", width: "100px" },
                { field: "imenosilca", title: "Nosilec", width: "150px" },
                { field: "naziv", title: "Žival", width: "160px" },
                { field: "skupinazivali", title: "Skupina živali" },
                { field: "vrstazivali", title: "Vrsta živali" },
                { field: "stevilo", title: "Število", width: "80px", filterable: false, type: "number", footerCell: 'nogaVsotaStevilo', width: "150px", format: '{0:n0}' },
                { field: "vsotagvz", title: "Vsota GVŽ", width: "80px", filterable: false, type: "number", footerCell: 'nogaVsotaGvz', width: "150px", format: '{0:n5}' },

                { field: "statuspridelkanaziv", title: "Status", width: "150px" },




                { field: "statuspridelovalca", title: "Status KMG", width: "150px", hidden: true },

                { field: "postnastevilka", title: "Poštna številka" },
                { field: "posta", title: "Pošta" },
                { field: "obcina", title: "Občina" },
                { field: "statisticnaregija", title: "Statistična regija" },
                { field: "kontrolnaorganizacija", title: "V kontroli pri" },
                { field: "naslovnosilca", title: "Naslov nosilca" },
                { field: "postnastevilkanosilca", title: "Poštna številka nosilca" },
                { field: "postanosilca", title: "Pošta nosilca" },

            ],
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],





        }
    },
    created() {




        if (!this.sezona) {
            this.sezona = Math.max(...this.sezoneBranje.map(s => s.sezona));
            this.dataSezona = { sezona: Math.max(...this.sezoneBranje.map(s => s.sezona)) };

        }
        else
            this.dataSezona = { sezona: this.sezona };
        this.getState()
        //this.loadVse({sezona:this.dataSezona.sezona});

    },
    computed: {
        pageable() {
            return { buttonCount: 3, pageSizes: [50, 100, this.gridData?.length] }
        },

        hiddenColumns() {
            return this.columns.filter(c => c.hidden);
        },
        ...mapState('users', ['userDetails', 'sezoneBranje']),
        ...mapState({
            gridData(state) {

                return state.zival.zival;
            }
        }),

    },
    watch: {
        sezoneBranje(newValue, oldValue) {
            this.sezona = Math.max(...this.sezoneBranje.map(s => s.sezona));
            this.dataSezona = { sezona: this.sezona };
        },
        skip(newValue, oldValue) {


            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);
        },
        take(newValue, oldValue) {


            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            }
            this.dataResult = process(this.gridData, dataState);
        },
        gridData(newValue, oldValue) {


            if (newValue) {

                const dataState = {
                    skip: this.skip,
                    take: this.take,
                    filter: this.filter,
                    sort: this.sort,
                    group: this.group
                };
                this.dataResult = process(this.gridData, dataState);

            }
        }
    },
    beforeRouteLeave(to, from, next) {
        console.log("SHRANIM STANJE!");
        this.saveState();
        next()


    },
    methods: {
        columnresize: function (e) {
            if (e.end) {
                let column = e.columns[e.index];
                let sc = this.columns.find(c => c.field == column.field)

                sc.width = e.newWidth;

            }
        },
        ...mapActions('zival', ['loadVse']),

        saveState: function () {
            const gridState = {};
            //gridState.data = [...this.gridData];
            gridState.sortable = this.sortable;
            gridState.filterable = this.filterable;
            gridState.groupable = this.groupable;
            gridState.skip = this.skip;
            gridState.take = this.take;
            gridState.group = this.group;
            gridState.sort = this.sort;
            gridState.filter = this.filter;
            gridState.columns = this.columns;
            gridState.sezona = this.dataSezona;

            localStorage.setItem('zivaliState' + this.$version, JSON.stringify(gridState));
            console.log(this.columns);
        },
        getState: function () {
            const gridState = JSON.parse(localStorage.getItem('zivaliState' + this.$version));

            if (gridState !== null) {
                //this.gridData = gridState.data;
                this.sortable = gridState.sortable;
                this.filterable = gridState.filterable;
                this.groupable = gridState.groupable;
                this.skip = gridState.skip;
                this.take = gridState.take;
                this.group = gridState.group;
                this.sort = gridState.sort;
                this.filter = gridState.filter;
                this.columns = gridState.columns;
                this.dataSezona = gridState.sezona;
                this.dataResult = process(this.gridData, {
                    skip: this.skip,
                    take: this.take,
                    sort: this.sort,
                    filter: this.filter,
                    group: this.group,
                });
            }
        },



        naloziPodatke: async function (e) {
            this.loading = true;
            if (!this.sezona) {
                this.dataSezona = { sezona: Math.max(...this.sezoneBranje.map(s => s.sezona)) };
                this.sezona = this.dataSezona.sezona;
            }
            else
                this.dataSezona = { sezona: this.sezona };
            this.loadVse(this.dataSezona).then(() => this.loading = false);
        },
        skrijStolpec: function (e) {
            let column = this.columns.find(c => c.field == e.dataItem.field)
            if (column)
                column.hidden = true;
            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);

        },
        prikaziStolpec: function (e) {
            let column = this.columns.find(c => c.field == e.dataItem.field)
            if (column)
                column.hidden = false;
            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);
        },
        nogaNazivVsot: function (h, emptyElement, props, listeners) {

            //seštevanje živali
            return h('span', {}, ['Vsota/število unikatnih MID-ov:']);
        },
        nogaVsotaStevilo: function () {
            if (this.dataResult.data) {
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                return kendo.toString(data.reduce((acc, current) => acc += current.stevilo, 0), "n0");
            }

        },
        nogaVsotaGvz: function () {
            if (this.dataResult.data) {
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                return kendo.toString(data.reduce((acc, current) => acc += current.vsotagvz, 0), "n5");
            }

        },
        nogaStMidov: function () {
            if (this.dataResult.data) {
                //naredi filter brez paginga...
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                var counts = {};
                for (var i = 0; i < data.length; i++) {
                    counts[data[i]["kmgmid"]] = 1 + (counts[data[i]["kmgmid"]] || 0);
                }
                return 'Vsota/število unikatnih MID-ov: '+ kendo.toString(Object.keys(counts).length, "n0");
            }

        },
        formatDate: function (h, emptyElement, props, listeners) {

            return h('td', { attrs: { colspan: 1 } }, [kendo.toString(kendo.parseDate(props.dataItem[props.field]), 'd')]);
        },



        sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona = sezona;

            this.$router.push({ name: 'zivali', params: { sezona: sezona.sezona } })
            this.dataSezona = sezona;
            this.loadVse(this.dataSezona);


        },


        createAppState: function (dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip ? dataState.skip : 0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;

        },

        dataStateChange(event) {

            this.createAppState(event.data);

            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });


        },

        exportExcel() {
            this.saveExcel({
                data: process(this.gridData, { sort: this.sort, filter: this.filter }).data,
                fileName: this.dataSezona.sezona + "_ZIVALI",
                columns: this.columns.filter(i => !i.hidden)
            });
        },




        pageChangeHandler: function (event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;

        }

    }
};
</script>
